import React from "react";
import { Form, Button, Input } from "antd";
import { UserOutlined, MailOutlined } from "@ant-design/icons";
import { getLanguage } from "@/lib/i18n";

interface props {
  loginToForgot?: any;
  dispatch: any;
  [lang: string]: any;
}

class ForgotForm extends React.Component<props, {}> {

  backToLogin = () => {
    this.props.loginToForgot();
  };

  handleSubmit = (values: any) => {
    // this.props.dispatch(putResetPassword(values));
  };

  render() {
    const { lang } = this.props;
    const language: any = getLanguage() ?? {};
    const t = language[lang] ?? {};
    return (
      <div className="admin-login-table">
        <p className="title">{t.login.forget_password_title}</p>
        <Form layout="inline" onFinish={this.handleSubmit}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: t.user.ALERT_USER_CREATE_2 }]}
          >
            <Input
              prefix={<UserOutlined className='icon-style' />}
              placeholder={t.user.username}
            />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[{ required: true, type: "email", message: t.error.invalid_email }]}
          >
            <Input
              prefix={<MailOutlined className='icon-style' />}
              placeholder={t.profile.email}
            />
          </Form.Item>

          <Form.Item>
            <div className="admin-login-select forgot">
              <Button onClick={this.backToLogin}>{t.button.back}</Button>
            </div>
            <div className="admin-login-submit forgot">
              <Button type="primary" htmlType="submit">
                {t.button.submit}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default ForgotForm;
